import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChamadoEmpresaChatComponent } from './chamado-empresa-chat.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: ChamadoEmpresaChatComponent}
  ])],
  exports: [RouterModule]
})
export class ChamadoEmpresaChatRoutingModule { }
